import { MenuItem, Select } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { constants } from "../../constants/constants";
import VesselInputs from "../../constants/VesselInputs";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import {
  addParentCat,
  checkParentCat,
  createActivityCategory,
  getCategoryOption,
  updateActivityCategory,
} from "../../utils/ApiCalls/Mobile/ActivityMasters";
import { getAncillary } from "../../utils/ApiCalls/Ancillary";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { useFlag } from "../../hooks";
import { FLAGS } from "../../utils/Constant/FlagConstant";
import { uploadData } from "../../utils/ApiCalls/Upload";
import { checkFields } from "../../utils/Validation/checkFields";
import UploadFileImage from "../imageUpload/uploadFileImage";
import ErrorPopup from "../mobile/popup/ErrorPopup";
import CheckSection from "./CheckSection";
import { checkPermission } from "../../utils/Validation/checkPermission";
import { message } from "antd";
import { LOG_ACTIONS, LOG_TYPES } from "../../utils/Constant/LogConstant.js";
import { addlog } from "../../utils/ApiCalls/Logs/index.js";



const ActivityCategorymasterInput = ({ activityCategory, vesselData }) => {
  const [title, setTitle] = useState("");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState("");
  const [type, setType] = useState("");
  const [actiontype, setActionType] = useState("");
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState("");
  const [description, setDescription] = useState("");
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");
  const [isActive, setIsActive] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseDescripton, setTraditionalChineseDescripton] =
    useState("");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [activitycategoryOption, setactivitycategoryOption] = useState([]);
  const [vessel, setVessel] = useState([]);
  const [parentCat, setParentCat] = useState();
  const [ancillaryId, setAncillaryId] = useState(null);
  const [ancillaryOptions, setAncillaryOptions] = useState([]);
  const { enabled: isPhase2 } = useFlag(FLAGS.APP_PHASE_2);
  const { enabled: isEntertainmentEnabled } = useFlag(
    FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT
  );
  const [shoreCMS, setShoreCMS] = useState({});
  const [api, setAPI] = useState("");
  const [shipCMS, setShipCMS] = useState({});
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [message1, setMessage1] = useState();
  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);
  const [link, setLink] = useState("");
  
  const [imageError, setImageError] = useState("");
  const [logoError, setLogoError] = useState("");
  const [imageRemoved, setImageRemoved] = useState(false);
  const [logoRemoved, setLogoRemoved] = useState(false);
  const imageUploadRef = useRef(null);
  const logoUploadRef = useRef(null);


  useEffect(() => {
    if (activityCategory) {
      setTitle(activityCategory?.name);
      setSelectedFile(activityCategory?.image);
      setLogoFile(activityCategory?.logo);
      setSimplifiedChineseTitle(activityCategory?.simplified_chinese_name);
      setTraditionalChineseTitle(activityCategory?.traditional_chinese_name);
      setDescription(activityCategory?.description);
      setIsActive(activityCategory?.is_active);
      setParentCat(activityCategory?.parent_category);
      setAncillaryId(activityCategory?.ancillary_id ?? null);
      setType(activityCategory?.type);
      setActionType(activityCategory?.action_type);
      setShoreCMS(activityCategory?.shore_cms || {});
      setShipCMS(activityCategory?.ship_cms || {});
      setAPI(activityCategory?.api);
      setLink(activityCategory?.link);
      setSimplifiedChineseDescription(
        activityCategory?.simplified_chinese_description
      );
      if (Array.isArray(vesselData)) {
        setVessel(vesselData?.map((item) => item.vessel_id));
      }
      setTraditionalChineseDescripton(
        activityCategory?.traditional_chinese_description
      );
    }
  }, [activityCategory, vesselData]);

  useEffect(() => {
    if (parentCat) {
      const parentOption = activitycategoryOption.find((item) => item.name === parentCat);
      setType(parentOption?.type || "");
      setActionType(parentOption?.action_type || "");
      setShoreCMS(parentOption?.shore_cms || {});
      setShipCMS(parentOption?.ship_cms || {});
    } else if (activityCategory) {
      setShoreCMS(activityCategory?.shore_cms || {});
      setShipCMS(activityCategory?.ship_cms || {});
    }
  }, [parentCat, activityCategory, activitycategoryOption]);

  const handleLocationChange = () => { };

  const validateVesselOnUpdate = () => {
  if (!activityCategory?.id) return true;

  if (!Array.isArray(vessel) || vessel.length === 0) {
    return "At least one vessel must be selected.";
  }

  const existingVessels = Array.isArray(vesselData)
    ? vesselData.map(v => v.vessel_id)
    : [];

  const missingVessels = existingVessels.filter(
    vId => !vessel.includes(vId)
  );

  if (missingVessels.length > 0) {
    const names = missingVessels
      .map(id => vesselOptions.find(v => v.id === id)?.name)
      .filter(Boolean)
      .join(", ");

    return `This category already exists for vessel(s): ${names}. You cannot remove them on update.`;
  }

  return true;
};


  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const location = useLocation()

  // File validation function
  const validateImageFile = (file, rules) => {
    if (!file) return Promise.resolve({ isValid: true, error: "" });

    // File type validation
    const allowedTypes = rules.allowedTypes || [
      'image/jpeg',
      'image/jpg', 
      'image/png',
      'image/webp',
      'image/svg+xml'
    ];
    
    if (!allowedTypes.includes(file.type)) {
      const formats = allowedTypes.map(t => t.split('/')[1].toUpperCase()).join(', ');
      return Promise.resolve({
        isValid: false,
        error: `Invalid file format. Only ${formats} files are allowed.`
      });
    }

    // File size validation
    const maxSize = rules.maxSize || 10 * 1024 * 1024; // Default 10MB
    if (file.size > maxSize) {
      return Promise.resolve({
        isValid: false,
        error: `File size exceeds maximum allowed size of ${maxSize / (1024 * 1024)}MB.`
      });
    }

    // Dimension validation (async)
    if (rules.dimensions) {
      return new Promise((resolve) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        
        img.onload = () => {
          URL.revokeObjectURL(objectUrl);
          const { width, height } = rules.dimensions;
          
          if (img.width !== width || img.height !== height) {
            resolve({
              isValid: false,
              error: `Image dimension must be ${width}x${height}px. Current dimension: ${img.width}x${img.height}px.`
            });
          } else {
            resolve({ isValid: true, error: "" });
          }
        };
        
        img.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          resolve({ 
            isValid: false, 
            error: "Invalid image file. Unable to read image dimensions." 
          });
        };
        
        img.src = objectUrl;
      });
    }

    return Promise.resolve({ isValid: true, error: "" });
  };

  // Handler for Category Image upload
  const handleCategoryImageChange = async (file) => {
    setImageError(""); // Clear previous errors
    
    if (!file) {
      setSelectedFile(null);
      return;
    }
    
    const validation = await validateImageFile(file, {
      maxSize: 10 * 1024 * 1024, // 10MB
      allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/svg+xml'],
      dimensions: { width: 600, height: 400 }
    });

    if (validation.isValid) {
      setSelectedFile(file);
      setImageError("");
    } else {
      setImageError(validation.error);
      setSelectedFile(null);
    }
  };

  // Handler for Category Logo upload
  const handleLogoChange = async (file) => {
    setLogoError(""); // Clear previous errors
    
    if (!file) {
      setLogoFile(null);
      return;
    }
    
    const validation = await validateImageFile(file, {
      maxSize: 10 * 1024 * 1024, // 10MB
      allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/svg+xml'],
      dimensions: { width: 40, height: 30 }
    });

    if (validation.isValid) {
      setLogoFile(file);
      setLogoError("");
    } else {
      setLogoError(validation.error);
      setLogoFile(null);
    }
  };

  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };
  const addcrisisData = async (e) => {
    e.preventDefault();

const vesselValidation = validateVesselOnUpdate();

if (vesselValidation !== true) {
  dispatch({
    type: "SET_ERROR_MESSAGE",
    errMess: {
      message: vesselValidation,
      type: "error",
    },
  });
  window.scrollTo({ top: 0, behavior: "smooth" });
  return;
}

  if (!parentCat) {
  const hasImage =
    selectedFile instanceof File ||
    (!!activityCategory?.image && !imageRemoved);

  const hasLogo =
    logoFile instanceof File ||
    (!!activityCategory?.logo && !logoRemoved);

  if (!hasImage) {
    setImageError("Category image is required.");
       imageUploadRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    return;
  }

  if (!hasLogo) {
    setLogoError("Category icon is required.");
      logoUploadRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    return;
  }
  }

    // Check for file validation errors
    if (imageError || logoError) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { 
          message: "Please fix file validation errors before submitting.", 
          type: "error" 
        },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataValues = {
      name: title,
      simplified_chinese_name: simplifiedChineseTitle,
      traditional_chinese_name: traditionalChineseTitle,
      description: description,
      simplified_chinese_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescripton,
      parent_category: parentCat,
      ancillary_id: ancillaryId || null,
      type,
      action_type: actiontype,
      shore_cms: shoreCMS,
      ship_cms: shipCMS,
      api: api,
      is_active: isActive ? 1 : 0,
      vessel: vessel,
      link,
    };
    let valid = checkFields(dataValues);
    if (parentCat) {
      let errorCat = await checkParentCat({ parentCat: parentCat, vessel });
      if (errorCat?.missing?.length > 0) {
        if (errorCat?.missing) {
          let msg = `<p>Missing <b>${activitycategoryOption?.find((item) => item.name == parentCat).name
            }</b> Parent Category for <b>`;
          errorCat.missing.map((val, index) => {
            msg += ` ${vesselOptions.find((item) => item.id == val)?.name} `;
            if (index == errorCat.missing.length - 1) {
              msg += ``;
            } else {
              msg += `, `;
            }
          });
          msg += `</b</p>`;
          setMessage1(msg);
        }
        setOpen(true);
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return errorCat;
      }
    }
    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        // No oldFileName: the old image can be shared with this category's other
        // vessel rows, so the server deletes it on save only once it is unused.
        let image = await uploadData(selectedFile);
        if (image?.error) throw new Error(image.error);

        dataValues.image = image?.url;
      }
    } else {
      dataValues.image = "";
    }
    if (logoFile) {
      if (typeof logoFile === "string") {
        dataValues.logo = logoFile.replace(constants.MEDIAURL + "/", "");
      } else {
        // No oldFileName: the old image can be shared with this category's other
        // vessel rows, so the server deletes it on save only once it is unused.
        let image = await uploadData(logoFile);
        if (image?.error) throw new Error(image.error);

        dataValues.logo = image?.url;
      }
    } else {
      dataValues.logo = "";
    }

    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (activityCategory?.id) {
        data = await updateActivityCategory(activityCategory?.id, {
          ...values,
          vesselData,
        });
       if (!data.error) { 
          addlog(
            LOG_ACTIONS.UPDATED,
            LOG_TYPES.CATEGORIES,
            {
              ...values,
              id: activityCategory?.id,
              title:`${title} Category, ${vesselOptions.find(v => v.id === vessel?.[0])?.name} vessel`,
              location_id: vessel?.[0],
            },
            userDetails.id)
        }
      } else {
        data = await createActivityCategory(values);
        if (!data.error) { 
          addlog(
            LOG_ACTIONS.CREATED,
            LOG_TYPES.CATEGORIES,
            {
              ...values,
              id: data.id,
              title:`${title} Category, ${vesselOptions.find(v => v.id === vessel?.[0])?.name} vessel`,
              location_id: vessel?.[0],
            },
            userDetails.id
          )
        }


      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return;
      }
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      if (!activityCategory?.id) {
       navigate("/shore/mobile-masters/activity-categories" + location.search);
      } else {
       navigate("/shore/mobile-masters/activity-categories" + location.search);
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };

  const handleUpdate = async () => {
    await addParentCat({ parentCat: parentCat, vessel });
    setOpen(false);
  };

  useEffect(() => {
    getOptionLocation();
  }, []);

  useEffect(() => {
    if (!isPhase2) return;
    getAncillary({ limit: 1000 }).then((res) => setAncillaryOptions(res?.data || []));
  }, [isPhase2]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let activity = await getCategoryOption({ limit: 1000 });
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      let vesselData = vessels.filter((item) =>
        checkPermission(
          permission,
          "read_per",
          "Categories",
          window?.location?.pathname +
          `/${item.name.toLowerCase().replaceAll(" ", "-")}`
        )
      );
      // setVesselId(vesselData[0]?.id);
      setVesselOptions(vesselData);
      // setVesselOptions(vessels);
      setactivitycategoryOption(activity?.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  return (
    <div>
      <ErrorPopup
        open={open}
        setOpen={setOpen}
        title={"Missing Record"}
        message={message1}
        buttonTitle={"Add Missing Data "}
        handleUpdate={handleUpdate}
      />
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcrisisData}>
              <div className="card-body">
                <div className="row">
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Categories English Title <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        required
                        value={title}
                        onChange={(e) => {
                          setTitle(e.target.value);
                        }}
                        className="f_input"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Category Simplified Chinese Title <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        required
                        value={simplifiedChineseTitle}
                        onChange={(e) => {
                          setSimplifiedChineseTitle(e.target.value);
                        }}
                        className="f_input"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Category Traditional Chinese Title <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        required
                        value={traditionalChineseTitle}
                        onChange={(e) => {
                          setTraditionalChineseTitle(e.target.value);
                        }}
                        className="f_input"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Vessels <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <VesselInputs
                        selectedValue={vessel}
                        // disabled={banner.id}
                        options={vesselOptions}
                        setSelectedValue={(e) => {
                          setVessel(e);
                        }}
                        style={{ width: "100%", height: "45px" }}
                        value={vessel}
                        onChange={(e) => handleLocationChange(e)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Parent Category </label>
                      <Select
                        style={{ width: "100%", height: "45px" }}
                        value={parentCat + ""}
                        onChange={(e) => setParentCat(e.target.value)}
                      >
                        <MenuItem value={undefined}>
                          <div>NA</div>
                        </MenuItem>
                        {activitycategoryOption.map((item, index) =>
                          item.name == activityCategory?.name ? null : (
                            <MenuItem key={index + ""} value={item?.name + ""}>
                              <div
                                dangerouslySetInnerHTML={{ __html: item.name }}
                              ></div>
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </div>
                  </div>

                  {isPhase2 && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">Ancillary</label>
                        <Select
                          style={{ width: "100%", height: "45px" }}
                          value={ancillaryId ?? ""}
                          onChange={(e) => setAncillaryId(e.target.value || null)}
                          displayEmpty
                        >
                          <MenuItem value=""><div>NA</div></MenuItem>
                          {ancillaryOptions.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.english_title}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )}
                  <div className="col-12">
                    <div className="fieldrow">
                      <label className="f_label">Category Description</label>
                      <ReactQuill
                        value={description}
                        onChange={(e) => {
                          setDescription(e);
                        }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  {parentCat == "" ||
                    (!parentCat && (
                      <div className="col-lg-6">
                        <UploadFileImage
                          ref={imageUploadRef}
                          className={""}
                          mandatory={"*"}
                          width={600}
                          height={400}
                          image={
                            activityCategory?.image
                              ? `${constants.MEDIAURL}/${activityCategory?.image}`
                              : activityCategory?.image
                          }
                          label={"Category  Image"}
                          placeholder={"Upload Category Image"}
                          selectedFile={selectedFile}
                          setSelectedFile={handleCategoryImageChange}
                           setRemoved={setImageRemoved}
                        />
                        {imageError && (
                          <p style={{ color: '#dc3545', fontSize: '13px', marginTop: '5px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <i className="ri-error-warning-line"></i>
                            {imageError}
                          </p>
                        )}
                      </div>
                    ))}
                  {parentCat == "" ||
                    (!parentCat && (
                      <div className="col-lg-6">
                        <UploadFileImage
                         ref={logoUploadRef}
                          className={""}
                          mandatory={"*"}
                          width={40}
                          height={30}
                          image={
                            activityCategory?.logo
                              ? `${constants.MEDIAURL}/${activityCategory?.logo}`
                              : activityCategory?.logo
                          }
                          label={"Category Icon"}
                          placeholder={"Upload Category icon "}
                          selectedFile={logoFile}
                          setSelectedFile={handleLogoChange}
                          setRemoved={setLogoRemoved}
                        />
                        {logoError && (
                          <p style={{ color: '#dc3545', fontSize: '13px', marginTop: '5px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <i className="ri-error-warning-line"></i>
                            {logoError}
                          </p>
                        )}
                      </div>
                    ))}
                  <div
                    style={{
                      pointerEvents: parentCat ? "none" : "auto",
                      opacity: parentCat ? 0.5 : 1, // optional: show it's disabled
                    }}
                    className="col-12 row"
                  >
                    <div className="col-12">
                      <div className="fieldrow">
                        <label
                          className="f_label"
                          style={{ marginBottom: "10px" }}
                        >
                          Set Primary Selection
                        </label>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            <span
                              className="checktitle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                height: "30px",
                              }}
                            >
                              <input
                                type="radio"
                                checked={type === "venue"}
                                onClick={(e) => {
                                  if (type == "venue") setType("");
                                  else {
                                    if (shoreCMS?.venue || shipCMS?.venue) {
                                      message.error(
                                        "Cannot Select Venue you already selected Venue in Key fields"
                                      );
                                    } else if (
                                      shoreCMS?.deck_location ||
                                      shipCMS?.deck_location
                                    ) {
                                      message.error(
                                        "Cannot Select Venue you already selected Deck Location in Key fields"
                                      );
                                    } else setType("venue");
                                  }
                                }}
                                name="selection"
                                value="venue"
                              />
                              Venue
                            </span>
                          </div>

                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            <span
                              className="checktitle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                height: "30px",
                              }}
                            >
                              <input
                                type="radio"
                                checked={type === "title"}
                                onClick={(e) =>
                                  type == e.target.value
                                    ? setType("")
                                    : setType(e.target.value)
                                }
                                name="selection"
                                value="title"
                              />
                              Title
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      {/* <CheckSection
                        dataObject={shoreCMS}
                        rootObj={shipCMS}
                        type={type}
                        setDataObject={setShoreCMS}
                        fields={[
                          { title: "Fidelio Code", name: "fidelio_code" },
                          { title: "Deck Location", name: "deck_location" },
                          { title: "Venue", name: "venue" },
                          { title: "Price", name: "price" },
                          { title: "Start time", name: "start_time" },
                          { title: "End time ", name: "end_time" },
                          { title: "No. of Participants", name: "no_of_pat" },
                          { title: "Remarks/Notes", name: "remarks" },
                          { title: "Upload Menu", name: "upload_menu" },
                          { title: "Cuisine", name: "cuisine" },
                          { title: "Port", name: "port" },
                          { title: "Duration", name: "display_duration" },
                          { title: "Restrictions", name: "restrictions" },
                          { title: "Availability Hours", name: "duration" },
                          { title: "Activity Level", name: "activity_level" },
                        ]}
                        title={"Static Input Fields"}
                      /> */}
                      <CheckSection
                        dataObject={shoreCMS}
                        rootObj={shipCMS}
                        type={type}
                        setDataObject={setShoreCMS}
                        fields={[
                          { title: "Fidelio Code", name: "fidelio_code" },
                          { title: "Revenue Center", name: "revenue_center" },
                          { title: "Deck Location", name: "deck_location" },
                          { title: "Venue", name: "venue" },
                          { title: "Price", name: "price" },
                          { title: "Start time", name: "start_time" },
                          { title: "End time ", name: "end_time" },
                          { title: "No. of Participants", name: "no_of_pat" },
                          { title: "Remarks/Notes", name: "remarks" },
                          { title: "Upload Menu", name: "upload_menu" },
                          { title: "Cuisine", name: "cuisine" },
                          { title: "Port", name: "port" },
                          { title: "Duration", name: "display_duration" },
                          { title: "Restrictions", name: "restrictions" },
                          { title: "Availability Hours", name: "duration" },
                          { title: "Activity Level", name: "activity_level" },
                        ].filter((f) => {
                          if (type === "venue") return f.name !== "deck_location" && f.name !== "venue";
                          if (f.name === "revenue_center" && !isEntertainmentEnabled) return false;
                          return true;
                        })}
                        title={"Static Input Fields"}
                      />

                    </div>
                    <div className="col-12">
                      {/* <CheckSection
                        type={type}
                        rootObj={shoreCMS}
                        dataObject={shipCMS}
                        setDataObject={setShipCMS}
                        fields={[
                          { title: "Fidelio Code", name: "fidelio_code" },
                          { title: "Deck Location", name: "deck_location" },
                          { title: "Venue", name: "venue" },
                          { title: "Price", name: "price" },
                          { title: "Start time", name: "start_time" },
                          { title: "End time ", name: "end_time" },
                          { title: "No. of Participants", name: "no_of_pat" },
                          { title: "Remarks/Notes", name: "remarks" },
                          { title: "Upload Menu", name: "upload_menu" },
                          { title: "Cuisine", name: "cuisine" },
                          { title: "Port", name: "port" },
                          { title: "Duration", name: "display_duration" },
                          { title: "Restrictions", name: "restrictions" },
                          { title: "Availability Hours", name: "duration" },
                          { title: "Activity Level", name: "activity_level" },
                        ]}
                        title={"Dynamic Input Fields"}
                      /> */}
                      <CheckSection
                        type={type}
                        rootObj={shoreCMS}
                        dataObject={shipCMS}
                        setDataObject={setShipCMS}
                        fields={[
                          { title: "Fidelio Code", name: "fidelio_code" },
                          { title: "Revenue Center", name: "revenue_center" },
                          { title: "Deck Location", name: "deck_location" },
                          { title: "Venue", name: "venue" },
                          { title: "Price", name: "price" },
                          { title: "Start time", name: "start_time" },
                          { title: "End time ", name: "end_time" },
                          { title: "No. of Participants", name: "no_of_pat" },
                          { title: "Remarks/Notes", name: "remarks" },
                          { title: "Upload Menu", name: "upload_menu" },
                          { title: "Cuisine", name: "cuisine" },
                          { title: "Port", name: "port" },
                          { title: "Duration", name: "display_duration" },
                          { title: "Restrictions", name: "restrictions" },
                          { title: "Availability Hours", name: "duration" },
                          { title: "Activity Level", name: "activity_level" },
                        ].filter((f) => {
                          if (type === "venue") return f.name !== "deck_location" && f.name !== "venue";
                          if (f.name === "revenue_center" && !isEntertainmentEnabled) return false;
                          return true;
                        })}
                        title={"Dynamic Input Fields"}
                      />

                    </div>
                    <div className="col-12">
                      <div className="fieldrow">
                        <label
                          className="f_label"
                          style={{ marginBottom: "10px" }}
                        >
                          Call to Action Type
                        </label>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            <span
                              className="checktitle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                height: "30px",
                              }}
                            >
                              <input
                                type="radio"
                                checked={actiontype === "purchase"}
                                onClick={(e) =>
                                  actiontype == "purchase"
                                    ? setActionType("")
                                    : setActionType("purchase")
                                }
                                name="actionType"
                                value="purchase"
                              />
                              Purchase
                            </span>
                          </div>

                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            <span
                              className="checktitle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                height: "30px",
                              }}
                            >
                              <input
                                type="radio"
                                checked={actiontype === "reserve"}
                                onClick={(e) =>
                                  actiontype == "reserve"
                                    ? setActionType("")
                                    : setActionType("reserve")
                                }
                                name="actionType"
                                value="reserve"
                              />
                              Reserve
                            </span>
                          </div>

                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            <span
                              className="checktitle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                height: "30px",
                              }}
                            >
                              <input
                                type="radio"
                                checked={actiontype === "link"}
                                onClick={(e) =>
                                  actiontype == "link"
                                    ? setActionType("")
                                    : setActionType("link")
                                }
                                name="actionType"
                                value="link"
                              />
                              Link
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {activityCategory?.id ? "Update" : "Add"} Activity Category
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default ActivityCategorymasterInput;
